import React from 'react';
import styled from 'styled-components';
// import Autosuggest from 'react-autosuggest';
// import CheckIcon from '../assets/icons/check-red.svg';
// import SearchIcon from '../assets/icons/search.svg';
// import OptionFilters from '../views/mockDraft/newDraft/optionFilters';
import defaultIcon from '../assets/icons/arrow-down.svg';
import { OutlineButtonIcon } from './buttons';
import { SvgIconContainer } from './icons';
import useComponentVisible from '../lib/hooks/useComponentVIsible';

export const RadioMark = styled.span`
    position: absolute; 
    height: 20px;
    width: 20px;
    top: 20px;
    left: 15px;
    border-radius: 50%;
    background-color: #ffffff;
    transition: background-color 0.25s;
`

export const RadioInput = styled.input`
    display: none;
    position: absolute;
    visibility: hidden;
    &:checked + ${RadioMark} {
        background-color: #d6001c;
        &::after {
            content: '';
            display: block;
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background-color: #ffffff;
            left: 5px;
            top: 5px;
            position: absolute;
        }
    }
`

const OptionLabel = styled.label`
    font-family: 'Roboto Condensed', sans-serif;
    font-size: 16px;
    margin-right: 24px;
    @media(max-width: 435px){
        margin-right: 15px;
    }
`;

const InputContainer = styled.div`
    display: ${props => props.hidden ? 'none' : 'flex'};
    margin: ${props => props.margin};
    width: ${props => props.width};
`;

const Select = styled.select`
    font-family: Roboto;
    font-size: 16px;
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
    &::-ms-expand {
        display: none;
    }
    outline: none;
    background-color: #000000;
    color: #ffffff;
    min-height: 39px;
    border: 0;
    border-radius: 0;
    border-bottom: 1px solid #808080;
    margin: ${props => props.margin};
    padding: ${props => props.inputPadding};
    width: 100%;
    &:hover {
        border-bottom: 1px solid #ffffff;
    }
    &:disabled {
        pointer-events: none;
    }
    & {
        option {
            background-color: #ffffff;
            color: #000000;
        }
    }
    background: ${props => `no-repeat right 0px center url(${props.icon || defaultIcon})`};
    transition: border-bottom 0.25s;
    cursor: pointer;
`;
const Input = styled.input`
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
    &::-ms-expand {
        display: none;
    }
    outline: none;
    font-size: 16px;
    background-color: #000000;
    color: #ffffff;
    min-height: 39px;
    border: 0;
    border-radius: 0;
    border-bottom: 1px solid #808080;
    margin: ${props => props.margin};
    padding: ${props => props.inputPadding};
    width: 100%;
    &:hover {
        border-bottom: 1px solid #ffffff;
    }
    background: ${props => `no-repeat right 0px center url(${props.icon || ''})`};
    transition: 0.25s border-bottom;
`;
const TextAreaInput = styled.textarea`
    height: auto;
    outline: none;
    font-family: 'Roboto',sans-serif;
    font-size: 16px;
    line-height: 16px;
    background-color: #161718;
    color: #ffffff;
    border: 0;
    border-radius: 0;
    border-bottom: 1px solid #808080;
    margin: ${props => props.margin};
    padding: ${props => props.inputPadding};
    width: 100%;
    &:hover {
        border-bottom: 1px solid #ffffff;
    }
    transition: 0.25s border-bottom;
    overflow: auto;
`;
const CustomSelectContainer = styled.div`
    display: ${props => props.expanded ? 'flex' : 'none'};
    position: absolute;
    top: 30px;
    z-index: 2;
`;
const CustomSelect = styled.div`
    border-top: 3px solid #d6001c;
    background-color: #161718;
    padding: 0px 30px 30px 40px;
`;
const CustomOption = styled.p`
    font-size: 16px;
    font-weight: 700;
    color: #FFFFFF;
    text-transform: uppercase;
    margin-top: 30px;
    cursor: pointer;
`;

export const SelectInput = ({ options, value, onChange, label, selectId, width, margin, inputPadding, icon, disabled }) => {
    return (
        <>
        {label &&
        <OptionLabel htmlFor={selectId}>
                {label}
            </OptionLabel>}
        <InputContainer width={width}>
            <Select value={value} onChange={onChange} id={selectId} inputPadding={inputPadding} margin={margin} icon={icon} disabled={disabled}>
                {options.map((opt,id) => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
            </Select>
        </InputContainer>
        </>
    )
}

export const OutlineButtonSelect = ({ options, value, onChange, label, selectId, width, margin, inputPadding, icon }) => {
    const { ref, isComponentVisible, setIsComponentVisible  } = useComponentVisible(false);
    return (
        <div style={{margin, position: 'relative'}} ref={ref}>
            <OutlineButtonIcon icon={icon} onClick={() => setIsComponentVisible(!isComponentVisible)}>{label}</OutlineButtonIcon>
            <CustomSelectContainer width={width} expanded={isComponentVisible}>
                <CustomSelect onChange={onChange} width={width} inputPadding={inputPadding}>
                    {options.map((opt,id) =>
                        <div style={{position: 'relative'}} key={opt.value}>
                            <SvgIconContainer show={value === opt.value} leftOffset="-25px">
                                <svg width="13px" height="11px" viewBox="0 0 13 11" version="1.1">
                                    <path d="M0 4.12836L3.25332 8L10 0" transform="translate(1.25 1.25)" id="Path-2" fill="none" stroke="#D6001C" strokeWidth="2.5" />
                                </svg>
                            </SvgIconContainer>
                            <CustomOption
                                key={opt.value}
                                onClick={() => { 
                                    onChange(opt.value);
                                    setIsComponentVisible(!isComponentVisible);
                                }}>
                                    {opt.label}
                            </CustomOption>
                        </div>
                    )}
                </CustomSelect>
            </CustomSelectContainer>
        </div>
    )
}

export const TextInput = ({ value, type, onChange, label, width, margin, inputPadding, placeholder, icon, min, max }) => {
    return (
        <>
        <InputContainer width={width}>
            <Input
                type={type || 'text'}
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                width={width}
                inputPadding={inputPadding}
                margin={margin}
                icon={icon}
                required={type === 'date'}
                min={min}
                max={max}
            >
            </Input>
        </InputContainer>
        </>
    )
}

export const TextArea = ({ value, type, onChange, label, width, margin, inputPadding, placeholder, icon, min, max }) => {
    function handleAutoSize(e){
        e.target.style.height = '27px';
        e.target.style.height = `${e.target.scrollHeight}px`; 
    }
    return (
        <>
        <InputContainer width={width}>
            <TextAreaInput
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                width={width}
                inputPadding={inputPadding}
                margin={margin}
                onKeyDown={handleAutoSize}
            >
            </TextAreaInput>
        </InputContainer>
        </>
    )
}